import { Component, Input, OnInit } from '@angular/core';
import { IAggregatorMonth } from '../models/aggregator.model';
import { MessageBoxTypesEnum } from '@dch/pxs-angular-design-system/src/lib/messages/message-box';

@Component({
  selector: 'my-bill-evolution-chart-new-customer-panel',
  templateUrl: './evolution-chart-new-customer-panel.component.html',
  standalone: false,
})
export class EvolutionChartNewCustomerPanelComponent implements OnInit {
  messageBoxTypeInformation = MessageBoxTypesEnum.Information;

  @Input() evolutionByMonth?: Array<IAggregatorMonth>;
  shouldDisplayPanel: boolean;

  ngOnInit() {
    this.shouldDisplayPanel =
      this.evolutionByMonth &&
      this.evolutionByMonth.every(
        (month) =>
          month.positiveDocuments.documents.length === 0 &&
          month.negativeDocuments.documents.length === 0
      );
  }
}
